import { render } from "./SelectItem.vue?vue&type=template&id=5b0e109b"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"

import "./SelectItem.vue?vue&type=style&index=0&id=5b0e109b&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__